import { motion } from 'framer-motion'

interface XPBarProps {
  currentXP: number
  maxXP: number
  totalXP: number
  level: number
}

export default function XPBar({ currentXP, maxXP, totalXP, level }: XPBarProps) {
  const progress = maxXP > 0 ? (currentXP / maxXP) * 100 : 0

  return (
    <div>
      <div className="flex justify-between items-center mb-2">
        <span className="text-sm text-gray-400">
          {currentXP.toLocaleString()} / {maxXP.toLocaleString()} XP
        </span>
        <span className="text-sm font-medium text-quest-accent">
          {totalXP.toLocaleString()} Total XP
        </span>
      </div>

      <div className="xp-bar relative">
        <motion.div
          className="xp-bar-fill"
          initial={{ width: 0 }}
          animate={{ width: `${progress}%` }}
          transition={{ duration: 0.5, ease: 'easeOut' }}
        />

        {/* Level milestone markers */}
        <div className="absolute inset-0 flex items-center justify-end pr-2">
          <span className="text-xs font-medium text-white/80">
            Level {level + 1}
          </span>
        </div>
      </div>

      <div className="flex justify-between mt-1">
        <span className="text-xs text-gray-500">Level {level}</span>
        <span className="text-xs text-gray-500">
          {Math.round(progress)}% to next level
        </span>
      </div>
    </div>
  )
}
